import React from "react";

function DropdownTitleWrapper(props) {
  return <>{props.children}</>;
}

export default DropdownTitleWrapper;
